module.exports = __webpack_public_path__ + "img/profile-arrow.b4c16419.svg";